import type { PayloadAction } from "@reduxjs/toolkit";
import { type CallEffect, call, type PutEffect, put, takeLatest } from "redux-saga/effects";
import {
	actions,
	REQUEST_GET_WORKSPACES,
	REQUEST_SET_CURRENT_WORKSPACE,
} from "src/redux/reducers/workspace";
import api from "src/services/authApi";
import type { ApiResponse } from "src/services/authApi/types";

function* getWorkspaces(): Generator<CallEffect | PutEffect, void, ApiResponse<Workspace[]>> {
	try {
		// The workspaces this user may switch to: every workspace for a superadmin,
		// their own memberships otherwise. /workspace is superadmin only, so the
		// switcher cannot use it.
		const response = yield call(api.get, `/user/me/workspaces`);

		if (response?.data) {
			yield put(actions.receiveGetWorkspaces(response.data));
		}
	} catch (error) {
		yield put(actions.failedGetWorkspaces(new Error("Could not get workspaces")));
	}
}

function* setCurrentWorkspace(
	action: PayloadAction<{ workspaceId: string }>,
): Generator<CallEffect | PutEffect, void, ApiResponse<Workspace[]>> {
	try {
		const response = yield call(api.patch, `/user/currentWorkspace`, {
			workspaceId: action.payload.workspaceId,
		});

		if (response?.data) {
			yield put(actions.receiveSetCurrentWorkspace());
		}
	} catch (error) {
		yield put(actions.failedSetCurrentWorkspace(new Error("Could not set current workspaces")));
	}
}

export default function* root() {
	yield takeLatest(REQUEST_GET_WORKSPACES, getWorkspaces);
	yield takeLatest(REQUEST_SET_CURRENT_WORKSPACE, setCurrentWorkspace);
}
